<template>
  <div class="atom-select-year">
    <div class="atom-select-year__container">
      <button class="atom-select-year__current" @click="handleCurrentClick">
        <span class="atom-select-year__current-label">{{ year }}</span>
        <svg
          v-if="yearList.length > 1"
          class="atom-select-year__arrow"
          :class="{ 'atom-select-year__arrow--open': isOpenOption }"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.93945 6L7.76268 11.8232C8.44609 12.5066 9.55413 12.5066 10.2375 11.8232L16.0608 6H13.9395L9.17689 10.7626C9.07926 10.8602 8.92097 10.8602 8.82334 10.7626L4.06077 6H1.93945Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <div class="atom-select-year__option" v-if="isOpenOption">
        <ul class="atom-select-year__option-list">
          <li v-for="item in yearList" :key="item" class="atom-select-year__option-item">
            <button
              class="atom-select-year__option-button"
              :class="{ 'atom-select-year__option-button--selected': currentYear === item }"
              @click="change(item)"
            >
              {{ item }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'

/**
 * 年度選択コンポーネント
 */
export default defineComponent({
  name: 'AtomSelectYear',
  props: {
    /**
     * 年度データ
     */
    currentYear: {
      type: Number,
      required: true,
    },
    /**
     * 選択年度
     */
    yearList: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  data() {
    return {
      year: this.currentYear,
      isOpenOption: false,
    }
  },
  methods: {
    change(item: number) {
      /**
       * 年度を選択されたことを通知する
       * @event change
       * @type {Object}
       */
      this.$emit('change', item)
      this.isOpenOption = false
    },
    handleCurrentClick() {
      this.isOpenOption = !this.isOpenOption
    },
  },
  watch: {
    currentYear(value) {
      this.year = value
    },
  },
})
</script>

<style lang="scss" scoped>
.atom-select-year {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;

  &__container {
    position: relative;
  }

  &__current {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 8px 16px;
    font-size: 16px;
    font-weight: 600;
    color: $white;
    letter-spacing: 0.04em;

    &-label {
      display: inline-block;
      min-width: 52px;
      line-height: 1;
    }
  }

  &__arrow {
    &--open {
      transform: rotate(180deg);
    }
  }

  &__option {
    position: absolute;
    top: 30px;
    left: 50%;
    width: 100%;
    overflow: hidden;
    background-color: $white;
    border: 1px solid $black10;
    border-radius: 4px;
    transform: translateX(-50%);

    &-item {
      + .atom-select-year__option-item {
        border-top: 1px solid $black10;
      }
    }

    &-button {
      display: block;
      width: 100%;
      padding: 6px 16px;
      text-align: left;
      white-space: nowrap;

      &--selected {
        background-color: #00dba6;
      }
    }
  }
}
</style>
